import { useState, useEffect, useMemo } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface UseRecommendedHotelsResult {
  recommendedHotelIds: Set<string>;
  isLoading: boolean;
  hasRecommendedHotels: boolean;
}

export function useRecommendedHotels(hotelIds: string[]): UseRecommendedHotelsResult {
  const [recommendedHotelIds, setRecommendedHotelIds] = useState<Set<string>>(new Set());
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (hotelIds.length === 0) {
      setRecommendedHotelIds(new Set());
      return;
    }

    const fetchRecommendedHotels = async () => {
      setIsLoading(true);
      try {
        // Query hotel_manual_info for hotels that have any evaluation
        const { data, error } = await supabase
          .from('hotel_manual_info')
          .select('hotel_id')
          .in('hotel_id', hotelIds);

        if (error) {
          console.error('Error fetching recommended hotels:', error);
          return;
        }

        const ids = new Set(data?.map(item => item.hotel_id) || []);
        setRecommendedHotelIds(ids);
      } catch (error) {
        console.error('Error fetching recommended hotels:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchRecommendedHotels();
  }, [hotelIds.join(',')]);

  const hasRecommendedHotels = useMemo(() => recommendedHotelIds.size > 0, [recommendedHotelIds]);

  return { recommendedHotelIds, isLoading, hasRecommendedHotels };
}
